import { ParameterSpecification } from './prarameter-specification.model';

export class SpecificationViewModel {
    testCode: string;
    testName: string;
    parameters?: ParameterSpecification[];
    parametersViewModels?: ParameterSpecification[];
    indeterminate?: boolean;
    checked?: boolean = false;
}
